import { Container, Text } from '@grupoboticario/flora-react';
import { HiOutlineSearch } from 'react-icons/hi';

interface NoContentProps {
  error: string;
}
export function NoContent({ error }: Readonly<NoContentProps>) {
  return (
    <Container css={{ padding: '3rem 6rem', textAlign: 'center' }}>
      <Text css={{ fontSize: '20px', lineHeight: 'normal' }}>{error}</Text>
      <div style={{ marginTop: '12px' }}>
        <Text>Tente reajustar os filtros.</Text>
        <HiOutlineSearch />
      </div>
    </Container>
  );
}
